import { Component } from '@angular/core';

@Component({
  selector: 'app-audio-transcription-dashboard',
  templateUrl: './audio-transcription-dashboard.component.html',
  styleUrls: ['./audio-transcription-dashboard.component.scss']
})
export class AudioTranscriptionDashboardComponent {

}
